import React from 'react';
import './radio.css';

interface HeartRadioProps {
  name: string;
  value: string;
  checked: boolean;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const HeartRadio: React.FC<HeartRadioProps> = ({
  name,
  value,
  checked,
  label,
  disabled,
  onChange,
}) => {
  return (
    <label className={`red-radio ${disabled ? 'custom-circle-disabled' : ''}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="custom-circle"/>
      <span className="radio-label">{label}</span>
    </label>
  );
};
